<template>
  <div class="card mb-4">
    <div class="card-body">
      <h4>{{ editMode ? 'Editar Categoría' : 'Nueva Categoría' }}</h4>
      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label class="form-label">Nombre</label>
          <input 
            type="text" 
            class="form-control" 
            v-model="nombre"
            required
            placeholder="Ej: Alimentación, Ocio, etc."
          >
        </div>
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary">
            {{ editMode ? 'Actualizar' : 'Crear' }}
          </button>
          <button 
            v-if="editMode" 
            type="button" 
            class="btn btn-secondary"
            @click="$emit('cancel-edit')"
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import axios from '../config/axios';

export default {
  name: 'CategoriaForm',
  
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    categoriaToEdit: {
      type: Object,
      default: null
    }
  },

  emits: ['categoria-added', 'categoria-updated', 'cancel-edit'],
  
  setup(props, { emit }) {
    const nombre = ref('');
    
    watch(() => props.categoriaToEdit, (newVal) => {
      if (newVal) {
        nombre.value = newVal.nombre;
      }
    }, { immediate: true });

    const handleSubmit = async () => {
      try {
        if (!nombre.value.trim()) {
          alert('El nombre es obligatorio');
          return;
        }

        if (props.editMode) {
          await axios.put(`/api/categorias/${props.categoriaToEdit.id}`, {
            nombre: nombre.value.trim()
          });
          emit('categoria-updated');
        } else {
          await axios.post('/api/categorias', {
            nombre: nombre.value.trim()
          });
          emit('categoria-added');
        }

        nombre.value = '';
      } catch (error) {
        console.error('Error:', error);
        alert('Error al guardar la categoría');
      }
    };

    return {
      nombre,
      handleSubmit
    };
  }
};
</script> 